import ApiService from '@/core/services/ApiService';
import { Actions, Mutations } from '@/store/enums/StoreEnums';
import { Module, Action, Mutation, VuexModule } from 'vuex-module-decorators';

export interface InfluencersObject {
  id: number;
  titleEn: string;
  titleAr: string;
  isActive: boolean;
}

export interface InfluencersListInfo {
  totalItems: number;
  currentPage: number;
  pageSize: number;
  isNext: boolean;
  previous: number;
  types: Array<InfluencersObject>;
  errors: unknown;
}

@Module
export default class InfluencersModule
  extends VuexModule
  implements InfluencersListInfo
{
  types = [] as Array<InfluencersObject>;
  allTypes = [] as Array<InfluencersObject>;
  totalItems = 0;
  currentPage = 1;
  pageSize = 10;
  previous = 0;
  isNext = true;
  errors = {};

  /**
   * Get types list
   * @returns Array<InfluencersObject>
   */
  get influencersList(): Array<InfluencersObject> {
    return this.types;
  }

  /**
   * Get all types list
   * @returns Array<PropertyTypeObject>
   */
  get allInfluencersList(): Array<InfluencersObject> {
    return this.allTypes;
  }

  /**
   * Get total items
   * @returns number
   */
  get influencersListCount(): number {
    return this.totalItems;
  }

  @Mutation
  [Mutations.SET_INFLUENCERS](data) {
    this.types = data.data;
    this.totalItems = data.totalItems;
    this.currentPage = data.currentPage;
    this.pageSize = data.pageSize;
    this.isNext = data.isNext;
    this.previous = data.previous;
    this.errors = {};
  }

  @Mutation
  [Mutations.SET_ALL_INFLUENCERS](data) {
    this.allTypes = data.data;
  }

  @Mutation
  [Mutations.RESET_INFLUENCERS_LIST]() {
    this.types = [] as Array<InfluencersObject>;
    this.totalItems = 0;
    this.currentPage = 1;
    this.pageSize = 10;
    this.previous = 0;
    this.isNext = true;
    this.errors = {};
  }

  // @Mutation
  // [Mutations.SET_ALL_AUCTION_PROPERTY_TYPES](data) {
  //   this.allTypes = data.data;
  // }

  @Mutation
  [Mutations.SET_INFLUENCERS_CURRENT_PAGE]() {
    this.types = [] as Array<InfluencersObject>;
    this.totalItems = 0;
    this.currentPage = 1;
    this.pageSize = 10;
    this.previous = 0;
    this.isNext = true;
    this.errors = {};
  }

  @Action
  [Actions.CREATE_INFLUENCER](data) {
    ApiService.setAuthorizationHeader();
    return ApiService.post('/influencers', data)
      .then(() => {
        this.context.commit(Mutations.SET_INFLUENCERS_CURRENT_PAGE);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, {
          [response.statusText]: [response.data.message],
        });
      });
  }

  @Action
  [Actions.DELETE_INFLUENCER](id) {
    ApiService.setAuthorizationHeader();
    return ApiService.delete('/influencers', id)
      .then(() => {
        this.context.commit(Mutations.SET_INFLUENCERS_CURRENT_PAGE);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, {
          [response.statusText]: [response.data.message],
        });
      });
  }

  @Action
  [Actions.UPDATE_INFLUENCER]({ id, data }) {
    ApiService.setAuthorizationHeader();
    return ApiService.update('/influencers', id, data)
      .then(() => {
        this.context.commit(Mutations.RESET_INFLUENCERS_LIST);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, {
          [response.statusText]: [response.data.message],
        });
      });
  }

  @Action
  [Actions.UPDATE_INFLUENCERS_CURRENT_PAGE](val) {
    this.context.commit(Mutations.SET_AUCTION_PROPERTY_TYPE_CURRENT_PAGE, val);
  }

  @Action
  [Actions.GET_INFLUENCER](id) {
    ApiService.setAuthorizationHeader();
    return ApiService.get('/influencers', id);
  }

  @Action
  [Actions.GET_INFLUENCERS]() {
    ApiService.setAuthorizationHeader();
    return ApiService.get('/influencers')
      .then(({ data }) => {
        this.context.commit(Mutations.SET_INFLUENCERS, data);
      })
      .catch(({ response }) => {
        console.error(response);
        // this.context.commit(Mutations.SET_ERROR, {
        //   [response.statusText]: [response.data.message],
        // });
      });
  }

  @Action
  [Actions.GET_ALL_INFLUENCERS]() {
    ApiService.setAuthorizationHeader();
    return ApiService.get('/influencers/all')
      .then(({ data }) => {
        this.context.commit(Mutations.SET_ALL_INFLUENCERS, data);
      })
      .catch(({ response }) => {
        console.error(response);
        // this.context.commit(Mutations.SET_ERROR, {
        //   [response.statusText]: [response.data.message],
        // });
      });
  }
}
